import PropTypes from 'prop-types';

export function SideJoke({ geeksJoke }) {
  return (
    <>
      <h4 className="my-2 text-lg font-semibold">Meanwhile...</h4>
      {geeksJoke.map((joke) => (
        <div key={joke.setup} className="text-sm xl:text-base">
          <dt>{joke.setup}</dt>
          <dd>
            <em>{joke.punchline}</em>
          </dd>
        </div>
      ))}
    </>
  );
}

SideJoke.propTypes = {
  geeksJoke: PropTypes.array.isRequired,
};
